import { render } from "./movimentos-list-grid.vue?vue&type=template&id=ba2975e0"
import script from "./movimentos-list-grid.vue?vue&type=script&lang=js"
export * from "./movimentos-list-grid.vue?vue&type=script&lang=js"

import "./movimentos-list-grid.vue?vue&type=style&index=0&id=ba2975e0&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__